import React from 'react';
import { Link } from 'react-router-dom';
import { resolveSrc } from './WidgetRender';

/** هیرو — زبان vibefarsi: بافت توری ملایم، بج، تیتر نمایشی، لید کوتاه و دکمه‌های تم‌محور. */
export default function SectionHero({ data, settings = {}, embedded }) {
  const img = resolveSrc(data.featured?.[0]?.media?.[0]?.path);
  const title = settings.title || 'نقره استریل دست‌ساز';
  const subtitle = settings.subtitle || 'حلقه و پلاک نام اختصاصی با حکاکی اثر انگشت نیمه‌ی شما؛ هر قطعه با عشق طراحی می‌شود.';

  const btnBase = {
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 8,
    minHeight: 'var(--shape-btn-h)', padding: '10px 26px', borderRadius: 'var(--shape-btn)',
    fontWeight: 700, fontSize: '0.95rem', textDecoration: 'none', cursor: 'pointer', fontFamily: 'inherit',
    transition: 'transform 0.15s, box-shadow 0.15s',
  };

  const inner = (
    <div style={{ position: 'relative', maxWidth: 720, margin: '0 auto' }}>
      {settings.badgeText && (
        <span style={{
          display: 'inline-block', padding: '6px 14px', borderRadius: 'var(--shape-btn)',
          border: 'var(--shape-line) solid var(--border)', background: 'var(--card)',
          color: 'var(--muted-fg)', fontSize: '0.78rem', fontWeight: 700, marginBottom: 20,
        }}>
          {settings.badgeText}
        </span>
      )}
      <h1 className="serif" style={{
        fontSize: settings.titleSize ? `${settings.titleSize}px` : 'clamp(2.1rem, 6vw, 3.8rem)',
        color: settings.titleColor || 'var(--fg)', margin: '0 0 16px', fontWeight: 700, lineHeight: 1.35,
      }}>
        {title}
      </h1>
      <p style={{
        fontSize: 'clamp(1rem, 2.5vw, 1.15rem)', color: settings.subtitleColor || 'var(--muted-fg)',
        maxWidth: 560, margin: '0 auto 30px', lineHeight: 2,
      }}>
        {subtitle}
      </p>
      {(settings.buttonText || settings.button2Text) && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, justifyContent: 'center' }}>
          {settings.buttonText && (
            <Link to={settings.buttonLink || '/products'} style={{ ...btnBase, background: 'var(--primary)', color: 'var(--on-primary)' }}
              onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; }} onMouseLeave={e => { e.currentTarget.style.transform = 'none'; }}>
              {settings.buttonText}
            </Link>
          )}
          {settings.button2Text && (
            <Link to={settings.button2Link || '/products'} style={{ ...btnBase, background: 'transparent', color: 'var(--fg)', border: 'var(--shape-line) solid var(--border)' }}
              onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; }} onMouseLeave={e => { e.currentTarget.style.transform = 'none'; }}>
              {settings.button2Text}
            </Link>
          )}
        </div>
      )}
      {img && (
        <img src={img} alt="" loading="lazy" style={{
          marginTop: 36, width: 'min(460px, 92%)', borderRadius: 'var(--shape-card)',
          border: 'var(--shape-line) solid var(--border)', boxShadow: '0 24px 60px -30px rgba(0,0,0,0.35)',
        }} />
      )}
    </div>
  );

  if (embedded) return <div style={{ width: '100%', textAlign: 'center', padding: 'clamp(40px, 7vw, 80px) 20px' }}>{inner}</div>;

  return (
    <section style={{
      position: 'relative', overflow: 'hidden', padding: 'clamp(56px, 10vw, 112px) 20px', textAlign: 'center',
      background: 'linear-gradient(160deg, var(--bg), color-mix(in srgb, var(--bg), var(--fg) 6%) 45%, color-mix(in srgb, var(--bg), var(--fg) 11%))',
      borderBottom: 'var(--shape-line) solid var(--border)',
    }}>
      {/* بافت توری ملایم — امضای بصری vibefarsi، رنگ‌محور از تم */}
      <div aria-hidden style={{
        position: 'absolute', inset: 0, pointerEvents: 'none',
        backgroundImage:
          'linear-gradient(to right, color-mix(in srgb, var(--fg) 6%, transparent) 1px, transparent 1px), linear-gradient(to bottom, color-mix(in srgb, var(--fg) 6%, transparent) 1px, transparent 1px)',
        backgroundSize: '48px 48px',
        maskImage: 'radial-gradient(ellipse at top, black 20%, transparent 70%)',
        WebkitMaskImage: 'radial-gradient(ellipse at top, black 20%, transparent 70%)',
      }} />
      {inner}
    </section>
  );
}
